import type { ReactNode } from 'react'

/**
 * Convert any heading's children (React nodes) into a stable, URL-safe anchor ID.
 * Works for both Devanagari and Latin text.
 *
 * Examples:
 *   "भय से मुक्ति आवश्यक है" → "भय-से-मुक्ति-आवश्यक-है"
 *   "About the Role"          → "about-the-role"
 */
export function headingId(children: ReactNode): string {
  const text = String(
    Array.isArray(children)
      ? (children as ReactNode[]).map(c => (typeof c === 'string' ? c : '')).join('')
      : children ?? ''
  )
  return text
    .trim()
    .replace(/\s+/g, '-')
    .replace(/[^\w\u0900-\u097F-]/g, '')
    .toLowerCase()
    .replace(/-{2,}/g, '-')
    .replace(/^-|-$/g, '')
    || 'section'
}
